import { render } from "./ContactComponents.vue?vue&type=template&id=804a0934"
import script from "./ContactComponents.vue?vue&type=script&lang=js"
export * from "./ContactComponents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__